module.exports = __webpack_public_path__ + "img/logo2.934b2012.png";